import React, { ReactNode } from "react";
import classes from "./ContentBlock.module.css";
import clsx from "clsx";

interface Props {
    children: ReactNode;
    className?: string;
    whiteText?: boolean;
    gradientBackground?: boolean;
}

const ContentBlock = ({ children, className, whiteText, gradientBackground }: Props) => {
    return (
        <div
            className={clsx(
                classes.contentBlock,
                gradientBackground && classes.contentBlock__gradient,
                whiteText && "whiteStyle",
                className && className,
            )}>
            {children}
        </div>
    );
};

export default ContentBlock;
